angular
    .module('MyApp')
    .service('ProjetosBolsasService', ['$resource', '$q', 'SessionData', 'Configs', function($resource, $q, SessionData, Configs) {



    }]);
